import BuyerSettings from './BuyerSettings';

export default BuyerSettings;
